import React, { useState, useContext, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AppContext } from '../../App';
import { useTitle } from '../Shared/CustomHooks';

const OsuLogin = ({ autoCompleteData, autoCompleteLoading, fetchAutoComplete }) => {
    useTitle('Login');
    const context = useContext(AppContext);

    const [loginFailed, setLoginFailed] = useState(false);
    const [loginRequest, setLoginRequest] = useState(false);
    //const [osuUser, setOsuUser] = useState({ IdToken: null });
    let rlocation = useLocation();

    const redirecToOsuShibbolethUrl = () => {
        window.location.href = window.location.href.toLowerCase().replace('osulogin', 'OsuShibboleth');
    };

    useEffect(() => {
        if (!autoCompleteLoading && !autoCompleteData) {
            fetchAutoComplete();
        }

        const osuKey = JSON.parse(sessionStorage.getItem('osuwmc_set_shibkey'));

        if (osuKey) {
            
            try {
                //console.log(JSON.stringify(osuKey))
                if (osuKey != null && osuKey.isAuthenticated) {
                    context.updateContext(osuKey);
                } else {
                    throw osuKey;
                }
            } catch (err) {
                console.log(err);
                context.updateContext(null);
                setLoginFailed(true);
            }   
        } else {
            setLoginRequest(true);
            redirecToOsuShibbolethUrl();
        }
    }, []);

    const from = rlocation.state?.from || '/ErrorsQueue';

    if (context.isAuthenticated === true) {
        return (<Navigate to={from} replace={true} />);
    }

    if (loginRequest) {
        return (<><div className="help-block">OSU Single Sign-On requested ...</div></>);
    }

    if (loginFailed) {
        return (<div className="help-block">OSU Single Sign-On failed!</div>);
    }

    return (<div className="help-block">Parsing OSU login information ...</div>);
};

export default OsuLogin;